import { useMemo } from 'react';
import { useStableParams } from '../routes/useStableParams';
import { ROOT_CATEGORY_ID } from '../components/global/_constants';

const useIsRootCategory = (): boolean => {
  const { slug } = useStableParams();

  return useMemo(() => slug === `${ROOT_CATEGORY_ID}`, [slug]);
};

export default useIsRootCategory;
